// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-34e3dbd8] .el-dialog__body{\n padding: 10px 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
